import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {prop as p, map as m, equals,__,isNil, path,compose as C, 
    inc, dec, findIndex, juxt, length, always, ifElse, nth } from "ramda";
import styles from './itemlabels.module.css';
import { setItem, toggle_expanded } from '../../store/load_data';
import { createSelector } from '@reduxjs/toolkit';
import { explain_mean } from '../../store/transforms/mean';
import { explain_share } from '../../store/transforms/share';
import { explain_dist } from '../../store/transforms/dist';
import select from "./sidepanel.selectors"

const explanations = {
    Means: explain_mean, 
    Columns:explain_dist, 
    Top5:explain_mean, 
    Share:explain_share, 
    Share2:explain_share 
} 
export const Itemlabels = ({item_labels,label,visual,is_active,current,unit,data,cls,multi}) => {
    const item = useSelector(p("item"));
    const comparison = useSelector(p("comparison"));
    const expanded = useSelector(p("expanded"));
    const scale = useSelector(p("color_meaning"));
    const dispatch = useDispatch();
    const country = useSelector(p("country"));
    const responses = useSelector(createSelector(m(p,["response_rates","country"]),
        (rates, country) => equals(0,path([Number(current.id),country],rates))));
    const units = useSelector(p("units"));
    const differences = useSelector(p("differences"));
    const missing_data = visual === "Top5" ? false : isNil(data[country]);
    
    return <div onClick={x => {if(is_active) x.stopPropagation()}} className={is_active ? styles.active : ""}>
        <div className={`${styles.hover_title} ${expanded ? styles.expanded : ""}`}>
            <button onClick={() => {dispatch(toggle_expanded())}}>{expanded ? "show" : "hide"} graph</button>
            <div>{(responses || missing_data) ? null : 
                p(visual, explanations)({comparison,item,item_labels,item,label,
                    scale,data,unit:units[current.id],diff:differences?.[current?.id]?.[country],country})}
            </div>
        </div>
    </div>;
};


/*     const [prev, next] = item_labels ? C(
        m(nth(__, item_labels)),
        juxt([
            ifElse(equals(dec(length(item_labels))), always(0), inc),
            ifElse(equals(0), always(dec(length(item_labels))), dec)
        ]),
        findIndex(equals(item)),
    )(item_labels) : []; */

{/* <div >{item ? C(...m(x => replace(...x), shorten))(item) : ""}</div> */}
/* {length(item_labels) > 1 ? <>
    <div className={styles.next_item} onClick={x => {if(is_active) {x.stopPropagation()} dispatch(setItem(next)); }}></div>
    <div className={styles.prev_item} onClick={x => {if(is_active) {x.stopPropagation()} dispatch(setItem(prev)); }}></div>
</> : ""} */

/* 
write out how many countries had values.
CUMULATIVE
    map to 
        min,max,G avg,C value,std,
        difference, 
        summed difference
        meaning
SHARE
        min,max,G avg,C value,std,
        difference
        meaning
MEAN
        min,max,G avg,C value,std,
        z-score
        difference
        meaning
TOP 5
    explanation of countrys destination scores, avg, on 0-100 scale, meaning
*/